import icono from "../../media/Mana Petita_Cmp.png";
import React from "react";
import "./LogoSection.css";
import NavigationButton from "../Button/NavigationButton";

export default function LogoSection() {
    return (
        <section className="logo-section" id="LogoSection">
            <img src={icono} className="app-logo" alt="Logotipo de Mana Petita" />
            <div className="logo-text">
                <p>Organización de bodas, eventos</p>
                <p>y cosas bonitas</p>
            </div>
            <NavigationButton path={"#ConocenosSection"} titulo={"¿Comenzamos?"} />
        </section>
    );
}
